import { Outlet } from 'react-router-dom';
import { ShieldCheck, Timer, Wallet } from 'lucide-react';
import { ThemeToggle } from '@/components/ThemeToggle';

/**
 * Split panel, not a card floating on empty canvas: the form owns the right
 * two-fifths on desktop and the context panel carries the brand. On narrow
 * screens the context panel collapses to a single line above the form so the
 * keyboard never pushes the fields off-screen.
 */
const POINTS = [
  {
    icon: Timer,
    title: 'Тридцать минут на подтверждение',
    body: 'У каждого входящего перевода идёт таймер. Подтвердите платёж или откройте спор, пока срок не истёк.',
  },
  {
    icon: Wallet,
    title: 'Обеспечение в USDT',
    body: 'Рубли приходят на ваши карты. USDT резервируются из обеспечения и зачисляются мерчанту после подтверждения.',
  },
  {
    icon: ShieldCheck,
    title: 'Только проверенные карты',
    body: 'Трафик идёт только на одобренные аккаунты. Верификация проходится один раз.',
  },
];

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-canvas lg:grid lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
      {/* Context panel */}
      <aside className="relative hidden flex-col justify-between border-r border-line bg-surface px-10 py-12 lg:flex xl:px-16">
        <div>
          <Wordmark />
        </div>

        <div className="max-w-md">
          <p className="eyebrow">Кабинет трейдера</p>
          <h1 className="mt-4 text-xl font-semibold leading-tight tracking-tight text-fg">
            Принимайте рубли на свои карты.
            <br />
            Управляйте обеспечением в USDT.
          </h1>

          <ul className="mt-10 space-y-6">
            {POINTS.map(({ icon: Icon, title, body }) => (
              <li key={title} className="flex gap-3.5">
                <Icon
                  size={16}
                  strokeWidth={1.5}
                  aria-hidden="true"
                  className="mt-0.5 shrink-0 text-fg-muted"
                />
                <div>
                  <p className="text-base font-medium text-fg">{title}</p>
                  <p className="mt-0.5 max-w-prose text-sm leading-normal text-fg-secondary">
                    {body}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <p className="num text-2xs text-fg-muted">
          p3p-pay · Кабинет трейдера v1.0
        </p>
      </aside>

      {/* Form panel */}
      <main className="safe-x flex min-h-screen flex-col px-5 py-8 sm:px-10 lg:justify-center lg:px-12">
        {/* Wraps: the wordmark plus a three-segment toggle at 44px each comes to
            267px, which only just clears a 320px viewport. */}
        <div className="mb-8 flex flex-wrap items-center justify-between gap-3 lg:hidden">
          <Wordmark />
          <ThemeToggle />
        </div>

        <div className="hidden justify-end lg:absolute lg:right-6 lg:top-6 lg:flex">
          <ThemeToggle />
        </div>

        <div className="mx-auto w-full max-w-sm">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function Wordmark() {
  return (
    <div className="flex items-baseline gap-2">
      <span className="text-md font-semibold tracking-tight text-fg">p3p-pay</span>
      <span className="num text-2xs uppercase tracking-wide text-fg-muted">Трейдер</span>
    </div>
  );
}
